import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {TakePicturePage} from '../../modals/take-picture/take-picture.page';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'picturestaken',
    templateUrl: './picturestaken.component.html',
    styleUrls: ['./picturestaken.component.scss'],
})
export class PicturestakenComponent implements OnInit {

    @Output() picturesChanged: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Input() document: DocumentModel;

    constructor(private modalController: ModalController) {
    }

    ngOnInit() {
    }

    async openModalPicture() {
        const modal = await this.modalController.create({
            component: TakePicturePage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
        });

        return await modal.present();
    }
}
